$(document).ready(() => {
  if (!$('html').hasClass('page-impact')) return;

  const headerOffset = $('header').height();
  // $('#MainContent').css('margin-top', -headerOffset);
  // $('[data-scroll-block]').first().css('margin-top', headerOffset);

  const blocks = $('[data-scroll-block]')

  $('.custom-scrollbar-line').css('height', 1 / blocks.length * 100 + '%');
  document.addEventListener('scroll', function () {
    let activeIndex = 0;
    for (let i = blocks.length - 1; i >= 0; --i) {
      const { top } = blocks[i].getBoundingClientRect();
      if (top < 0) {
        activeIndex = i;
        break;
      }
    }

    $('.custom-scrollbar-line').css('height', (activeIndex + 1) / blocks.length * 100 + '%');
  })
});
